import { render, staticRenderFns } from "./pageSearch.vue?vue&type=template&id=7cb05bc6&"
import script from "./pageSearch.vue?vue&type=script&lang=js&"
export * from "./pageSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports